/*  hab-journal.js — Wave 12.0 (stub) · Wave 12.1 (filled) · 25 Jul 2026
    ───────────────────────────────────────────────────────────────────────
    Client-side behaviour for the Field Journal templates
    (blog + article). Loaded from layout/theme.liquid gated on
    template.name == 'blog' or template.name == 'article'.

    Wave 12.1 fills these three behaviours (article page):
      · reading-progress bar — window scroll → article-body length ratio
      · auto-built sticky TOC — scans .hab-article__content h2[id]
        and populates the empty <ol class="hab-article__toc-list">, then
        wires an IntersectionObserver to add .on to the active link
      · copy-link share button — navigator.clipboard.writeText on click
    ─────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var boot = function () {
    var root = document.querySelector('.hab-ed.hab-journal, .hab-ed.hab-article');
    if (!root) return;

    // ── reading-progress bar (article only) ──
    var progressBar = document.querySelector('.hab-ed .hab-article__progress > i');
    var body = document.querySelector('.hab-ed .hab-article__body');
    if (progressBar && body) {
      var onScroll = function () {
        var rect = body.getBoundingClientRect();
        var total = body.offsetHeight - window.innerHeight;
        var seen = Math.max(0, -rect.top);
        var pct = total > 0 ? Math.min(100, (seen / total) * 100) : 0;
        progressBar.style.width = pct + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    // ── auto-built TOC ──
    // Scan .hab-article__content h2 elements; assign IDs if missing;
    // populate the empty <ol> the section rendered.
    var tocRoot = document.querySelector('.hab-ed .hab-article__toc[data-hab-toc]');
    var tocList = tocRoot ? tocRoot.querySelector('.hab-article__toc-list') : null;
    var contentEl = document.querySelector('.hab-ed .hab-article__content');
    var tocLinks = [];
    if (tocList && contentEl) {
      var h2s = contentEl.querySelectorAll('h2');
      if (h2s.length === 0) {
        // No sections → hide the whole TOC card so the rail stays clean
        tocRoot.style.display = 'none';
      } else {
        var slugify = function (s) {
          return String(s || '')
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .slice(0, 80) || 'section';
        };
        var usedIds = {};
        h2s.forEach(function (h2, i) {
          var id = h2.id;
          if (!id) {
            id = slugify(h2.textContent);
            if (usedIds[id]) id = id + '-' + (i + 1);
            usedIds[id] = 1;
            h2.id = id;
          } else {
            usedIds[id] = 1;
          }
          h2.style.scrollMarginTop = '80px';
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + id;
          a.textContent = h2.textContent;
          if (i === 0) a.className = 'on';
          li.appendChild(a);
          tocList.appendChild(li);
          tocLinks.push({ el: h2, link: a });
        });
      }
    }

    // ── TOC active-state via IntersectionObserver ──
    if (tocLinks.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var match = tocLinks.find(function (t) { return t.el === e.target; });
          if (!match) return;
          tocLinks.forEach(function (l) { l.link.classList.remove('on'); });
          match.link.classList.add('on');
        });
      }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
      tocLinks.forEach(function (t) { io.observe(t.el); });
    }

    // ── copy-link share button ──
    var copyBtns = root.querySelectorAll('[data-hab-copy-link]');
    copyBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('data-hab-copy-link') || window.location.href;
        if (!navigator.clipboard) {
          // Fallback: select + execCommand copy
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try { document.execCommand('copy'); } catch (_) {}
          document.body.removeChild(ta);
          return;
        }
        navigator.clipboard.writeText(url).then(function () {
          var prev = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = prev; }, 1600);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
